import { css } from '@emotion/css';

export const styleListPart = css`
  
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
  behavior: smooth;
  scroll-behavior: smooth;

  .Header{
    background-color: white;
    box-shadow: 0 8px 12px rgb(18 18 18 / 16%);
    padding-top: calc(60px + 3vw);
    padding-bottom: calc(10px + 1vw);
  }

  .buatKanan{
    display: flex;
    justify-content: flex-start;
    margin-left:0;
    padding-top: calc(40px + 2vw);
    padding-bottom:0;
    height:100%;
  }

  .col{
    margin:0;
    padding-left:0;
    padding-right:0;
  }

  .row{
    margin:0;
    padding-left:0;
    padding-right:0;
  }

  .buatCover{
    display: inline-block flex;
    float:right;
    justify-content: flex-end;
    align-items: right;
  }

  .gambarCover{
    width:calc(100px + 15vw);
    display: flex;
    justify-content: flex-end;
    align-items: right;
  }

  .isinya{
    justify-content: center;
    align-items: center;
  }

  .ceritanyaCard{
    justify-content: center;
    align-items: center;
  }

  .rowKanan{
    width:calc(100px + 15vw);
    padding-left:0;
    padding-bottom:0;
    display: inline-block flex;
  }

  .judulnya{
    width:calc(150px + 10vw);
    padding-left:0;
    font-size: calc(11px + 2vw);
    font-family: "Source Sans Pro", sans-serif;
    padding-bottom:0;
    margin-bottom:calc(10px + 1vw);
  }

  .tombolBaca{
    width:230px;
    padding-left:0;
    font-size: calc(20px + 1vw);
    font-family: "Source Sans Pro", sans-serif;
    padding-right:0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color:#222;
    border-radius: 35px;
    cursor: pointer;
    transition: background-color 0.1s;
    box-shadow:0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  }

  .tombolBaca:hover{
    width:230px;
    padding-left:0;
    font-size: calc(20px + 1vw);
    font-family: "Source Sans Pro", sans-serif;
    padding-right:0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color:black;
    border-radius: 35px;
    cursor: pointer;
    box-shadow:0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  }

  .logoBuku{
    margin-right:0.3vw;
    height: calc(10px + 1vw);
  }

  .katakata{
    font-size: calc(10px + 1vw);
    font-family: "Source Sans Pro", sans-serif;
    padding-right:0;
    display:flex;
    text-align:center;
    color:white;
    display: flex;
    margin:0;
    padding-top:7px;
    padding-bottom:7px;
    justify-content: center;
    align-items: center;
  }

  .buatItem{
    padding-top:calc(10px + 2vw);
    padding-bottom:calc(10px + 2vw);
    justify-content: center;
    align-items: flex-start;
    top:0;
    display:flex;
  }

  .bawah{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left:7vw;
    margin-right:7vw;
    margin-top:5vw;
    border-color: #fff;
    border-style: solid;
    max-width: 100%;
    box-shadow: 0 8px 12px rgb(18 18 18 / 16%);
    background-color: white;
  }
  
  .buatPart{
    margin-right:20px;
    margin-left:20px;
    background-color:white;
  }

  .headerList{
    font-size: calc(15px + 1vw);
    font-family: "Source Sans Pro", sans-serif
    display:flex;
    text-align:center;
    color:black;
    padding-top:calc(15px + 1vw);
    padding-bottom: 1vw;
  }

  .tulisanChapter{
    font-size: calc(15px + 1vw);
    font-family: 'Poppins', sans-serif;
    display: inline-block;
    color:black;
    margin-left:2vw;
    cursor: pointer;
  }

  .tulisanChapter:hover{
    font-size: calc(15px + 1vw);
    font-family: 'Poppins', sans-serif;
    display: inline-block;
    color:black;
    margin-left:2vw;
    text-decoration: underline;
    cursor: pointer;
  }

  .sekatChapter{
    height:10px;
  }

  .sekatBawah{
    height:calc(15px + 1vw);
  }

`;
